// Saved Map/Calendar filters, read back for API calls.
//
// FilterCalendarMap (the Filters popup) saves the applied filters per zone in
// sessionStorage under `mapFilters_<zoneId>`. Most values are stored as arrays of
// ids; MapGrid_api / MapCanvas_api expect comma-separated strings.
//
// RON-6136: the refreshes after a booking or a new meeting used to send every
// filter as "", so the map showed all spots while the popup still showed the
// saved filter. They now send the zone's saved filters through this helper.

export const MAP_FILTERS_SESSION_PREFIX = "mapFilters_";

const toApiValue = (value) => (Array.isArray(value) ? value.join(",") : value || "");

// The saved filters of a zone as API strings. No zone, nothing saved or
// unreadable data -> every filter "" (the unfiltered map, as before).
export const getStoredMapFilterPayload = (zoneId) => {
  let saved = {};

  if (zoneId) {
    try {
      saved = JSON.parse(sessionStorage.getItem(`${MAP_FILTERS_SESSION_PREFIX}${zoneId}`) || "{}") || {};
    } catch {
      saved = {};
    }
  }

  return {
    // FacilityFilterApiValue is what the popup actually sent: "" when every
    // enabled space type is selected (= all), so prefer it over the raw ids.
    FacilityFilter: toApiValue(saved.FacilityFilterApiValue ?? saved.FacilityFilter),
    VehicleTypeFilter: toApiValue(saved.VehicleTypeFilter),
    FuelFilter: toApiValue(saved.FuelFilter),
    FilterStartTime: toApiValue(saved.FilterStartTime),
    FilterEndTime: toApiValue(saved.FilterEndTime),
    TagsFilter: toApiValue(saved.TagsFilter),
    AccessibleFilter: toApiValue(saved.AccessibleFilter),
    ShareableFilter: toApiValue(saved.ShareableFilter),
  };
};
